/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

/* eslint-disable */
import Vue from 'vue';
import {
  CHECK,
  REGISTER,
  LOGIN,
  LOGOUT,
  USER_FETCHED,
} from './mutation-types';
import { ls } from '@/utils/localStorageTtl';

export default {
  [CHECK](state) {
    try {
      state.authenticated = !!ls.get('id_token');

      if (ls.get('user')) {
        state.user = JSON.parse(ls.get('user'));
        state.admin = state.user.admin;
      }

      if (state.authenticated) {
        Vue.$http.defaults.headers.common.Authorization = `Bearer ${ls.get('id_token')}`;
      } else {
        // remove because of ttl expired
        state.admin = false;
        localStorage.removeItem('id_token');
        localStorage.removeItem('user');
        localStorage.removeItem('admin');
        Vue.$http.defaults.headers.common.Authorization = '';
      }
    } catch (err) {
      // remove because of parsing error
      state.authenticated = false;
      state.admin = false;
      state.user = {};
      localStorage.removeItem('id_token');
      localStorage.removeItem('user');
      localStorage.removeItem('admin');
      Vue.$http.defaults.headers.common.Authorization = '';
    }
  },

  [REGISTER]() {

  },

  [LOGIN](state, payload) {
    state.authenticated = true;
    state.user = payload.user;
    state.admin = payload.user.admin;
    ls.set('id_token', payload.token, payload.ttl);
    ls.set('user', JSON.stringify(payload.user), payload.ttl);
    if (payload.user.admin === 1) {
      ls.set('admin', 1, payload.ttl);
    }
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${payload.token}`;
  },

  [LOGOUT](state) {
    state.authenticated = false;
    state.admin = false;
    state.user = null;
    localStorage.removeItem('id_token');
    localStorage.removeItem('user');
    localStorage.removeItem('admin');
    Vue.$http.defaults.headers.common.Authorization = '';
    Vue.router.push({
      name: 'login.index',
    });
  },

  [USER_FETCHED](state, payload) {
    // eslint-disable-next-line
    state.user = Object.assign({}, state.user, payload);
    ls.set('user', JSON.stringify(state.user), 3600000);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js